import React from "react";
import { css } from "emotion";
import { defaultStyle } from "./style";

const CardTag = ({ children, show, color }) => {
	return (
		!!show && (
			<div
				className={css`
					${defaultStyle};
				`}
			>
				<div className={color}>{children}</div>
			</div>
		)
	);
};

export default CardTag;
